import React, { useState } from 'react'
import { TextField, Row, Column, Button, Spacing, MultiStep } from 'quantic'
import { useForm } from 'react-hook-form'
import NotAuthenticatedLayout from 'components/templates/Layout/NotAuthenticated'
import { Title } from './styles'

function ValidateCertificate() {
  const { register, handleSubmit, errors } = useForm()
  const [currentStep, setCurrentStep] = useState(0)
  const [fields, setFields] = useState({})

  const onSubmit = (data) => data

  const onAdvanceStep = (data) => {
    const TOTAL_STEPS = 2
    setFields((prev) => ({ ...prev, ...data }))

    if (currentStep === TOTAL_STEPS) return onSubmit({ ...fields, ...data })
    return setCurrentStep(currentStep + 1)
  }

  return (
    <NotAuthenticatedLayout>
      <MultiStep currentIndex={currentStep} onChangeStep={setCurrentStep} uncontrolled>
        <MultiStep.Step title="E-mail">
          <form key="email" onSubmit={handleSubmit(onAdvanceStep)}>
            <Row>
              <Column size={12}>
                <Title>Esqueceu a senha?</Title>
              </Column>
              <Column size={12}>
                <TextField
                  ref={register({
                    required: 'Campo obrigatório',
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: 'Formato de e-mail inválido',
                    },
                  })}
                  name="email"
                  label="E-mail"
                  error={errors.email?.message}
                  fullWidth
                />
              </Column>
              <Spacing size="xs" />
              <Column size={12}>
                <Button primary fullWidth type="submit">
                  Enviar código
                </Button>
              </Column>
            </Row>
          </form>
        </MultiStep.Step>
        <MultiStep.Step title="Nova Senha">
          <form key="code" onSubmit={handleSubmit(onAdvanceStep)}>
            <Row>
              <Column size={12}>
                <Title>Esqueceu a senha?</Title>
              </Column>
              <Column size={12}>
                <TextField
                  ref={register({ required: 'Campo obrigatório' })}
                  name="code"
                  label="Código Recebido"
                  error={errors.code?.message}
                  fullWidth
                />
              </Column>
              <Column size={12}>
                <TextField
                  ref={register({ required: 'Campo obrigatório' })}
                  name="newPassword"
                  label="Nova Senha"
                  error={errors.newPassword?.message}
                  fullWidth
                />
              </Column>
              <Column size={12}>
                <TextField
                  ref={register({ required: 'Campo obrigatório' })}
                  name="newPasswordConfirmation"
                  label="Confirmar nova senha"
                  error={errors.newPasswordConfirmation?.message}
                  fullWidth
                />
              </Column>
              <Spacing size="xs" />
              <Column size={12}>
                <Button primary fullWidth type="submit">
                  Redefinir senha
                </Button>
              </Column>
            </Row>
          </form>
        </MultiStep.Step>
      </MultiStep>
    </NotAuthenticatedLayout>
  )
}

export default ValidateCertificate
